import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getReferalDetail, updateCaseOfficialUseHistory, updateReferalDetail } from '../../services/Admin/adminServices';
import { Modal, Button, Card, Form } from 'react-bootstrap';
import { Formik, Field, Form as FormikForm, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import toast from 'react-hot-toast';

const CaseDetails = () => {
  const { id } = useParams();
  const [caseDetail, setCaseDetail] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const getDetails = async () => {
    try {
      const res = await getReferalDetail(id);
      setCaseDetail(res?.data?.data);
    } catch (error) {

      console.error('Error fetching case details:', error);
 
     
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  if (!caseDetail) return <div>Loading...</div>;

  const handleSubmit = async (values) => {
    try {


      const payload={
          caseReferralId: caseDetail._id,
        officialUseHistory: values,
      }
      await  updateReferalDetail(payload);
      setShowModal(false);
      getDetails(); // Refresh data
    } catch (error) {
      console.error('Error updating case:', error);
    }
  };

  const validationSchema = Yup.object({
    isCaseAppropriate: Yup.boolean().required('Required'),
    nextStepsOrRecommendations: Yup.string().required('Required'),
  });

  const {
    justiceCentre,
    dateOfReferral,
    timeOfReferral,
    dateOfIncident,
    typeOfReferral,
    referrerRelationshipToparties,
    nameOfReferrer,
    addressOfReferrer,
    harmedPartyName,
    harmedPartyTelephone,
    wrongdoerName,
    wrongdoerTelephone,
    relationshipBtwParties,
    harmIdentified,
    description,
    rjProcessExplained,
    createdBy,
    minimumRequirements,
    discretionaryFactors,
    officialUseHistory,
  } = caseDetail;

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
    <h2 className="mb-3" style={{color:"#0AB7EA"}}>Case Details</h2>
 
      </div>

      {/* Referral Info */}
   <Card className="mb-3 p-3">
  <h5 className="mb-3">Referral Info</h5>
  
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Justice Centre:</div>
    <div className="col-8">{justiceCentre}</div>
  </div>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Date of Referral:</div>
    <div className="col-8">{new Date(dateOfReferral).toLocaleDateString()}</div>
  </div>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Time of Referral:</div>
    <div className="col-8">{timeOfReferral}</div>
  </div>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Date of Incident:</div>
    <div className="col-8">{new Date(dateOfIncident).toLocaleDateString()}</div>
  </div>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Type of Referral:</div>
    <div className="col-8">{typeOfReferral}</div>
  </div>
  <div className="row">
    <div className="col-4 fw-semibold">Referrer Relationship:</div>
    <div className="col-8">{referrerRelationshipToparties}</div>
  </div>
</Card>


   {/* Referrer Info */}
<Card className="mb-3 p-3">
  <h5 className="mb-3">Referrer Details</h5>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Name:</div>
    <div className="col-8">{nameOfReferrer}</div>
  </div>
  <div className="row">
    <div className="col-4 fw-semibold">Address:</div>
    <div className="col-8">{addressOfReferrer}</div>
  </div>
</Card>

{/* Harmed Party */}
<Card className="mb-3 p-3">
  <h5 className="mb-3">Harmed Party</h5>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Name:</div>
    <div className="col-8">{harmedPartyName}</div>
  </div>
  <div className="row">
    <div className="col-4 fw-semibold">Telephone:</div>
    <div className="col-8">{harmedPartyTelephone}</div>
  </div>
</Card>

{/* Wrongdoer */}
<Card className="mb-3 p-3">
  <h5 className="mb-3">Wrongdoer</h5>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Name:</div>
    <div className="col-8">{wrongdoerName}</div>
  </div>
  <div className="row">
    <div className="col-4 fw-semibold">Telephone:</div>
    <div className="col-8">{wrongdoerTelephone}</div>
  </div>
</Card>

{/* Relationship & Harm */}
<Card className="mb-3 p-3">
  <h5 className="mb-3">Relationship & Harm</h5>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Relationship Between Parties:</div>
    <div className="col-8">{relationshipBtwParties}</div>
  </div>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Harm Identified:</div>
    <div className="col-8">{harmIdentified}</div>
  </div>
  <div className="row">
    <div className="col-4 fw-semibold">Description:</div>
    <div className="col-8">{description}</div>
  </div>
</Card>

{/* Restorative Justice */}
<Card className="mb-3 p-3">
  <h5 className="mb-3">Restorative Justice Process</h5>
  <div className="row">
    <div className="col-12">{rjProcessExplained}</div>
  </div>
</Card>

{/* Created By */}
<Card className="mb-3 p-3">
  <h5 className="mb-3">Created By</h5>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Name:</div>
    <div className="col-8">{createdBy?.name}</div>
  </div>
  <div className="row">
    <div className="col-4 fw-semibold">Email:</div>
    <div className="col-8">{createdBy?.email}</div>
  </div>
</Card>

{/* Minimum Requirements */}
<Card className="mb-3 p-3">
  <h5 className="mb-3">Minimum Requirements</h5>
  {Object.entries(minimumRequirements || {}).map(([key, value]) => (
    <div className="row mb-2" key={key}>
      <div className="col-4 fw-semibold text-capitalize">{key}:</div>
      <div className="col-8">{value}</div>
    </div>
  ))}
</Card>

{/* Discretionary Factors */}
<Card className="mb-3 p-3">
  <h5 className="mb-3">Discretionary Factors</h5>
  {Object.entries(discretionaryFactors?.factorsConsidered || {}).map(([key, value]) => (
    <div className="row mb-2" key={key}>
      <div className="col-4 fw-semibold text-capitalize">{key}:</div>
      <div className="col-8">{value}</div>
    </div>
  ))}

  <div className="row mb-2">
    <div className="col-4 fw-semibold">Victim Agreed To Participate:</div>
    <div className="col-8">{discretionaryFactors?.victimAgreedToParticipate}</div>
  </div>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Community Need For Restorative Result:</div>
    <div className="col-8">{discretionaryFactors?.communityNeedForRestorativeResult}</div>
  </div>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Potential Ongoing Relationship:</div>
    <div className="col-8">{discretionaryFactors?.potentialOngoingRelationship}</div>
  </div>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Offender Benefit & Possible Agreement:</div>
    <div className="col-8">{discretionaryFactors?.offenderBenefitAndPossibleAgreement}</div>
  </div>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Potential Meaningful Agreement:</div>
    <div className="col-8">{discretionaryFactors?.potentialMeaningfulAgreement}</div>
  </div>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Harm To Victim Considered:</div>
    <div className="col-8">{discretionaryFactors?.harmToVictimConsidered}</div>
  </div>
  <div className="row">
    <div className="col-4 fw-semibold">Exceptional Circumstances:</div>
    <div className="col-8">{discretionaryFactors?.exceptionalCircumstances}</div>
  </div>
</Card>

{/* Official Use History */}
<Card className="mb-3 p-3">
  <h5 className="mb-3">Official Use History</h5>
  <div className="row mb-2">
    <div className="col-4 fw-semibold">Is Case Appropriate:</div>
    <div className="col-8">{officialUseHistory?.isCaseAppropriate ? "Yes" : "No"}</div>
  </div>
  <div className="row">
    <div className="col-4 fw-semibold">Next Steps / Recommendations:</div>
    <div className="col-8">{officialUseHistory?.nextStepsOrRecommendations}</div>
  </div>
</Card>

      {/* Edit Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Official Use History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              isCaseAppropriate: officialUseHistory?.isCaseAppropriate || false,
              nextStepsOrRecommendations: officialUseHistory?.nextStepsOrRecommendations || '',
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, handleChange }) => (
              <FormikForm>
                <Form.Group className="mb-3">
                  <Form.Label>Is Case Appropriate?</Form.Label>
                  <Field as="select" name="isCaseAppropriate" className="form-control">
                    <option value={true}>Yes</option>
                    <option value={false}>No</option>
                  </Field>
                  <ErrorMessage name="isCaseAppropriate" component="div" className="text-danger" />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Next Steps / Recommendations</Form.Label>
                  <Field
                    as="textarea"
                    name="nextStepsOrRecommendations"
                    className="form-control"
                    rows={3}
                  />
                  <ErrorMessage name="nextStepsOrRecommendations" component="div" className="text-danger" />
                </Form.Group>

                <div className="d-flex justify-content-end">
                  <Button variant="secondary" className="me-2" onClick={() => setShowModal(false)}>Cancel</Button>
                  <Button variant="primary" type="submit">Save Changes</Button>
                </div>
              </FormikForm>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CaseDetails;
